// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import SxGraphqlClientInteropJs from "./SxGraphqlClientInterop.js";
import * as GraphqlClientCtx$LiteracyplanetClientFlags from "./GraphqlClientCtx.res.mjs";

function queryGraphqlAsync(prim0, prim1) {
  return SxGraphqlClientInteropJs(prim0, prim1);
}

function SxGraphqlClient$Provider(props) {
  return React.createElement(GraphqlClientCtx$LiteracyplanetClientFlags.Provider.make, {
              value: {
                queryGraphqlAsync: SxGraphqlClientInteropJs(props.idToken, props.accessToken)
              },
              children: props.children
            });
}

var Provider = {
  make: SxGraphqlClient$Provider
};

export {
  queryGraphqlAsync ,
  Provider ,
}
/* react Not a pure module */
